import { getTarifaCliente } from '../services/dashboardService'

import types from './types'

const { SET_TARIFA_CLIENTE } = types

export default function fetchTarifaCliente(idConta) {
  if (!idConta) {
    console.warn('idConta não informado para consulta de tarifas.')
    return Promise.resolve([])
  }

  return dispatch =>
    getTarifaCliente(idConta)
      .then(tarifas => {
        dispatch({
          type: SET_TARIFA_CLIENTE,
          tarifas: tarifas || []
        })
        return tarifas
      })
      .catch(error => {
        console.error('Erro em #fetchTarifaCliente()', error)
        dispatch({ type: SET_TARIFA_CLIENTE, tarifas: [] })
        return []
      })
}
